// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__20HDB","title":"Images90_title__3gusi","images":"Images90_images__1-q20"};